import { render } from "./ImportantReport.vue?vue&type=template&id=f8332342"
import script from "./ImportantReport.vue?vue&type=script&lang=js"
export * from "./ImportantReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__